module.exports = __webpack_public_path__ + "static/media/right.bd59b7a7.svg";